import React from 'react';
import { Paper, Icon, Typography, Divider, List, ListItem, ListItemText, Select, MenuItem, LinearProgress } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import { makeStyles } from '@material-ui/core/styles';
import NodesTable from '../../NodesTable';
import { TEMPORARY_MIG_MODES } from '../../util';

const useStyles = makeStyles(theme => ({
	card: {
		minWidth: 275
	},
	listItem: {
		color: 'secondary',
		textDecoration: 'none!important',
		height: 40,
		paddingLeft: 24,
		paddingRight: 12,
		'&.active': {
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.secondary.contrastText + '!important',
			pointerEvents: 'none',
			'& .list-item-icon': {
				color: 'inherit'
			}
		},
		'& .list-item-icon': {
			marginRight: 16
		}
	},
	selectedItem: {
		color: 'secondary',
		textDecoration: 'none!important',
		height: 40,
		paddingLeft: 24,
		paddingRight: 12,
		backgroundColor: '#f2f2f2',
		'&.active': {
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.secondary.contrastText + '!important',
			pointerEvents: 'none',
			'& .list-item-icon': {
				color: 'inherit'
			}
		},
		'& .list-item-icon': {
			marginRight: 16
		}
	},
}));

const NodesTab = ({ 
	nodes, 
	nodeFilter, 
	selectedNodeItem, 
	nodeStateFilters,
	isMigModeSupported,
	migMode,
	migModeSettingInProgress,
	handleMigModeChange,
	setMigModeSettingInProgress
}) => {
	const classes = useStyles();

	if (!nodes) return null;

	return (
		<div className="w-full flex flex-row items-start justify-between">
			<div className={`${classes.card} p-0 lg:p-24 lg:pr-4 w-1/4`}>
				<FuseAnimate animation="transition.slideLeftIn" delay={200}>
					<Paper className="mb-10 rounded-0 shadow-none lg:rounded-8 lg:shadow-1">
						<div className="flex items-center px-16 h-64 border-b-1">
							<Icon className="text-black text-20 pr-56">list</Icon>
							<Typography className="text-16">Cluster Nodes</Typography>
						</div>
						<Divider />
						<List>
							{nodeStateFilters.map(item => (
								<ListItem
									key={item.id}
									id={item.id}
									button
									onClick={() => {
										if (item.onClick) {
											item.onClick();
										}
									}}
									className={`${classes.listItem} ${selectedNodeItem === item.id ? classes.selectedItem + ' active' : ''}`}
								>
									<Icon className={`list-item-icon text-16 ${item.iconColor}`} color="action">
										{item.icon}
									</Icon>
									<ListItemText className="truncate pr-0" primary={item.text} disableTypography={true} />
									<ListItemText className="flex justify-end" primary={item.primaryData} disableTypography={true} />
								</ListItem>
							))}
						</List>
					</Paper>
				</FuseAnimate>
				{isMigModeSupported() && migMode && (
					<FuseAnimate animation="transition.slideLeftIn" delay={200}>
						<Paper className="rounded-0 shadow-none lg:rounded-8 lg:shadow-1">
							<div className="flex items-center px-16 h-64 border-b-1">
								<Icon className="text-black text-20 pr-56">apps</Icon>
								<Typography className="text-16">MIG Mode</Typography>
							</div>
							{migModeSettingInProgress ? <LinearProgress /> : <Divider />}
							<div className="flex items-center justify-center w-full">
								<Select
									className="w-5/6 my-10"
									id="cluster_view_mig-mode-select"
									value={migMode}
									label="MIG Mode"
									onChange={event => {
										handleMigModeChange(undefined, event.target.value);
										setMigModeSettingInProgress(true);
									}}
									disabled={migModeSettingInProgress}
								>
									{TEMPORARY_MIG_MODES.map(mode => {
										return (
											<MenuItem value={mode} key={mode}>
												{mode}
											</MenuItem>
										);
									})}
								</Select>
							</div>
						</Paper>
					</FuseAnimate>
				)}
			</div>
			<div className="p-16 sm:p-24 w-full">
				<NodesTable nodes={nodes} filter={nodeFilter} />
			</div>
		</div>
	);
};

export default NodesTab;
